module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_noutomi-8474b506bb3f355217d97fce53852e9d.jpg";